var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 26,
    viewBox: "0 0 44 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 44,
    height: 26,
    transform: "translate(-0.166 -0.699)",
    fill: "#333",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(0.166 0.699)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_",
    transform: "translate(6.461 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    d: "M356.618,217.638h13.215a11.249,11.249,0,0,0-3.418,3.109h-9.8a.815.815,0,0,0-.814.814v14.868a.815.815,0,0,0,.814.814h14.868a.815.815,0,0,0,.814-.814v-9.906a7.271,7.271,0,0,1,1.174-.482,3,3,0,0,0,1.465,1.731,2.963,2.963,0,0,0,.471.177v8.48a3.928,3.928,0,0,1-3.923,3.923H356.618a3.928,3.928,0,0,1-3.923-3.923V221.561A3.927,3.927,0,0,1,356.618,217.638Z",
    transform: "translate(-352.695 -215.758)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    d: "M9.067,142.948a9.276,9.276,0,0,0-7.616,4.29A.787.787,0,0,1,0,146.824v-.094a9.286,9.286,0,0,1,9.066-9.28v-1.469a.92.92,0,0,1,1.44-.76l6.242,4.272a.823.823,0,0,1,0,1.356l-6.24,4.327a.919.919,0,0,1-1.444-.756Z",
    transform: "translate(13.64 -135.059)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIco);
export default __webpack_public_path__ + "static/media/completeIco.c0b4838c8b8f4558fc9f73807d78bc1c.svg";
export { ForwardRef as ReactComponent };